import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import ReactTable from 'react-table';
import Moment from '../../../components/utils/Moment';
import ReviewForm from './ReviewForm';
import PatientAlerts from './PatientAlerts';
import VisitNoteCard from './VisitNoteCard';

import { getAlerts, getAlertClass } from '../utils/alerts';

export default class VisitView extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    actions: PropTypes.object.isRequired,
    isActionsLoading: PropTypes.bool,
    bullets: PropTypes.object.isRequired,
    isBulletsLoading: PropTypes.bool,
    limits: PropTypes.array,
    encounters: PropTypes.object.isRequired,
    isEncountersLoading: PropTypes.bool,
    showNotes: PropTypes.bool,
    editFlagsMode: PropTypes.bool,
    toggleNotes: PropTypes.func,
    addAction: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.labelEditClick = this.labelEditClick.bind(this);
  }

  getActionClass = action => {
    if (action.markResolved) {
      return 'fa-thumbs-up';
    }
    if (action.markReviewed) {
      return 'fa-check';
    }
    if (action.setFollowUp) {
      return 'fa-question';
    }
    if (action.clearMskFlag || action.setMskFlag) {
      return 'fa-flag';
    }
    if (action.target === 'msk') {
      return 'fa-flag';
    }
    return 'fa-comment';
  };

  getActionWording = action => {
    const wordings = [];
    if (action.markResolved) {
      wordings.push('Mark Resolved');
    }
    if (action.markReviewed) {
      wordings.push('Mark Reviewed');
    }
    if (action.setFollowUp) {
      wordings.push('Set for Follow Up');
    }
    if (action.clearMskFlag) {
      wordings.push('Cleared MSK Flag');
    }
    if (action.setMskFlag) {
      wordings.push('Set MSK Flag');
    }
    if (!action.setFollowUp && !action.markReviewed && !action.markResolved && !action.clearMskFlag && !action.setMskFlag) {
      if (action.target === 'msk') {
        wordings.push('Commented on MSK Flag');
      } else {
        wordings.push('Commented');
      }
    }
    return wordings.join(' and ');
  };

  sortedActions = () => {
    return this.props.actions.list.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  };

  labelEditClick = () => {
    this.props.toggleNotes(true, true);
  }

  isICDInLookup = (code) => {
    const { lookups: { icd }, data: info } = this.props;
    if (!icd || !(info.mskFlag === 'Y' || (info.mskFlag === 'N' && !!info.mskFlag2 && info.mskFlag !== 'N/A'))) {
      return false;
    }
    return icd.some(el => el.icd10 === code);
  }

  render() {
    const showNotes = this.props.showNotes;
    const {
      limits,
      data: info,
      toggleNotes,
      actions,
      addAction,
      encounters,
      view,
      bullets,
      medications,
      isActionsLoading,
      isBulletsLoading,
      isEncountersLoading,
      isActionSubmitting,
      isMedicationsLoading,
      editFlagsMode,
      history,
      isHistoryLoading
    } = this.props;
    const alerts = getAlerts(info, limits);
    let mskFlagClass = '';
    if (info && info.mskFlag === 'Y' && info.mskFlag2 === 'yes') {
      mskFlagClass = 'danger';
    } else if (info && info.mskFlag === 'Y' && info.mskFlag2 === 'maybe') {
      mskFlagClass = 'warning';
    } else if (info && info.mskFlag === 'Y' && (info.mskFlag2 === 'N/A' || info.mskFlag2 === 'no')) {
      mskFlagClass = 'info';
    } else if (info && info.mskFlag === 'N' && !!info.mskFlag2 && info.mskFlag2 !== 'N/A' && info.mskFlag2 !== 'no') {
      mskFlagClass = 'danger';
    }

    const filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      const rowId = isNaN(row[id]) ? row[id].toLowerCase() : row[id];
      const filterValue = isNaN(filter.value) ? filter.value.toLowerCase() : filter.value;
      return (
        row[id] !== undefined && row[id] !== null ?
          String(rowId).includes(filterValue) : true
      );
    };

    return (
      <div>
        {info && (
          <div>
            <div className="widget-body clinic-activity-widget-body">
              <div className="chart-review-body" ref="VisitView">
                <div className="row">
                  <div className="col-xs-6">
                    <span className="review-label">Visit Note ID</span>
                    <br />
                    <strong>{info.visitNoteID}</strong>{' '}
                    {info.signedBy === null && (
                      <span className="label label-warning">
                        <i className="fa fa-unlock" />{' '}
                        <span className="hidden-xs">Unlocked</span>
                      </span>
                    )}
                    {info.signedBy !== null && (
                      <span className="label label-success">
                        <i className="fa fa-lock" />{' '}
                        <span className="hidden-xs">Locked</span>
                      </span>
                    )}
                  </div>
                  <div className="col-xs-6">
                    <span className="review-label">Date</span>
                    <br />
                    <Moment date={info.dateOfService} format="MM/DD/YYYY" />
                  </div>
                  <div className="col-sm-4 col-xs-6">
                    <span className="review-label">Patient ID</span>
                    <br />
                    <a href={`https://www.app.elationemr.com/patient/${info.patientID}/`} target="_blank">{info.patientID}</a> {info.patientName ? info.patientName : ''}
                  </div>
                  <div className="col-sm-8 col-xs-6">
                    <span className="review-label">Actions</span>
                    <br />
                    {info.isFollowUp && (
                      <span className="label label-info">F/U</span>
                    )}
                    {info.isReviewed && (
                      <span className="label label-default">Reviewed</span>
                    )}
                    {info.isResolved && (
                      <span className="label label-success">Resolved</span>
                    )}
                    &nbsp;
                  </div>
                  <div className="col-sm-4 col-xs-6">
                    <span className="review-label">Visit Type</span>
                    <br />
                    {info.visitReason}
                    &nbsp;
                  </div>
                  <div className="col-sm-2 col-xs-3">
                    <span className="review-label">Age</span>
                    <br />
                    {info.age}
                    &nbsp;
                  </div>
                  <div className="col-sm-6 col-xs-3">
                    <span className="review-label">Gender</span>
                    <br />
                    {info.sex}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">HCC&nbsp;Total</span>
                    <br />
                    {info.totalHcc}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">Prospective&nbsp;Risk</span>
                    <br />
                    {info.prospectiveRiskScore &&
                      `${info.prospectiveRiskScore.toFixed(2)}%`}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">Concurrent&nbsp;Risk</span>
                    <br />
                    {info.concurrentRiskScore &&
                      `${info.concurrentRiskScore.toFixed(2)}%`}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">
                      Chronic&nbsp;Conditions
                    </span>
                    <br />
                    {info.chronicFlag}
                    &nbsp;
                  </div>
                  <div className="col-sm-6 col-xs-6">
                    <span className="review-label">Reason for Visit</span>
                    <br />
                    {info.reason}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3 flags">
                    <span className="review-label">Flags</span>
                    <br />
                    {view === 'PROTOCOL_FLAGS' &&
                      <span>
                        {info.mskFlag === 'Y' && info.mskFlag2 === 'yes' && (
                          <span onClick={this.labelEditClick} className="label label-danger clickable">MSK <i className="fa fa-pencil"></i></span>
                        )}
                        {info.mskFlag === 'Y' && info.mskFlag2 === 'maybe' && (
                          <span onClick={this.labelEditClick} className="label label-warning clickable">MSK <i className="fa fa-pencil"></i></span>
                        )}
                        {info.mskFlag === 'Y' && (info.mskFlag2 === 'no' || info.mskFlag2 === 'N/A') && (
                          <span onClick={this.labelEditClick} className="label clickable" style={{ backgroundColor: '#000' }}>MSK <i className="fa fa-pencil"></i></span>
                        )}
                      </span>
                    }
                    {view !== 'PROTOCOL_FLAGS' &&
                      <span>
                        {info.mskFlag === 'Y' && info.mskFlag2 === 'yes' && (
                          <span className="label label-danger">MSK</span>
                        )}
                        {info.mskFlag === 'Y' && info.mskFlag2 === 'maybe' && (
                          <span className="label label-warning">MSK</span>
                        )}
                        {info.mskFlag === 'Y' && (info.mskFlag2 === 'no' || info.mskFlag2 === 'N/A') && (
                          <span className="label" style={{ backgroundColor: '#000'}}>MSK</span>
                        )}
                      </span>
                    }
                    {info.mskFlag === 'N' && !!info.mskFlag2 && info.mskFlag2 !== 'N/A' && (
                      <span onClick={this.labelEditClick} className="label label-default clickable">MSK <i className="fa fa-pencil"></i></span>
                    )}
                    {info.diabetesFlag === '1' && (
                      <span className="label label-danger">Diabetes</span>
                    )}
                    &nbsp;
                  </div>
                  <div className="col-sm-3  col-xs-3 alerts">
                    <span className="review-label">Alerts</span>
                    <br />
                    <PatientAlerts alerts={alerts} />
                    &nbsp;
                  </div>
                  <div className="col-sm-6">
                    <span className="review-label">Signed by</span>
                    <br />
                    {info.signedBy} <em>{info.practiceName ? info.practiceName : ''}</em>
                  </div>
                </div>
                <hr className="simple" />
                <ul id="myTab1" className="nav nav-tabs">
                  <li className="active">
                    <a href="#s1" data-toggle="tab" aria-expanded="true">
                      <i className="fa fa-fw fa-lg fa-user-md hidden-xs" /> Note{' '}
                    </a>
                  </li>
                  <li>
                    <a href="#s2" data-toggle="tab" aria-expanded="false">
                      <i className="fa fa-fw fa-lg fa-hospital-o hidden-xs" />{' '}
                      History{' '}
                      {isHistoryLoading && <div className="spinner" />}
                    </a>
                  </li>
                  <li>
                    <a href="#s3" data-toggle="tab" aria-expanded="false">
                      <i className="fa fa-fw fa-lg fa-history hidden-xs" />{' '}
                      Encounters{' '}
                      {isEncountersLoading && <div className="spinner" />}
                      {encounters &&
                        encounters.total > 0 &&
                        !isEncountersLoading && (
                          <span className="badge bg-color-blue txt-color-white">
                            {encounters.total}
                          </span>
                        )}
                    </a>
                  </li>
                  <li>
                    <a href="#s4" data-toggle="tab" aria-expanded="false">
                      <i className="fa fa-fw fa-lg fa-comments hidden-xs" />{' '}
                      Actions{' '}
                      {isActionsLoading && <div className="spinner" />}
                      {actions &&
                        actions.total > 0 && !isActionsLoading && (
                          <span className="badge bg-color-blue txt-color-white">
                            {actions.total}
                          </span>
                        )}
                    </a>
                  </li>
                </ul>
                <div id="myTabContent1" className="tab-content padding-10">
                  <div className="tab-pane fade active in" id="s1">
                    <div className="row">
                      <div className="col-sm-6">
                        <h2>
                          <i className="fa fa-file-text-o" /> Visit Notes
                        </h2>
                        <dl>
                          <dt>History Present Illness</dt>
                          <dd>{info.historyPresentIllness}</dd>
                          <dt>Problem</dt>
                          <dd>{info.problem}</dd>
                          <dt>Active Problems</dt>
                          <dd>
                            {[info.patientProblem1, info.patientProblem2,
                            info.patientProblem3, info.patientProblem4].filter(val => (val !== null && val !== '')).join(', ')}
                          </dd>
                        </dl>
                      </div>
                      <div className="col-sm-6">
                        <h6>
                          <i className="fa fa-stethoscope" /> Vitals
                        </h6>
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            <table className="table table-bordered table-condensed">
                              <thead>
                                <tr>
                                  <th>BP</th>
                                  <th>HR</th>
                                  <th>Temp</th>
                                  <th>RR</th>
                                  <th>
                                    O<sub>2</sub>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className={getAlertClass(alerts, 'BP')}>
                                    {info.bpS}/{info.bpD}
                                  </td>
                                  <td>{info.HR}</td>
                                  <td>{info.temp}</td>
                                  <td>{info.RR}</td>
                                  <td>{info.O2}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="table-responsive">
                            <table className="table table-bordered table-condensed">
                              <thead>
                                <tr>
                                  <th>Ht</th>
                                  <th>Wt</th>
                                  <th>BMI</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{info.height}</td>
                                  <td>{info.weight}</td>
                                  <td className={getAlertClass(alerts, 'BMI')}>{info.BMI}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="table-responsive">
                            <table className="table table-bordered table-condensed">
                              <thead>
                                <tr>
                                  <th>A1C</th>
                                  <th>INS</th>
                                  <th>TG</th>
                                  <th>HDL</th>
                                  <th>LDL</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className={getAlertClass(alerts, 'A1C')}>{info.A1C}</td>
                                  <td className={getAlertClass(alerts, 'INS')}>{info.insulin}</td>
                                  <td className={getAlertClass(alerts, 'TG')}>{info.triglycerides}</td>
                                  <td className={getAlertClass(alerts, 'HDL')}>{info.hdlCholesterol}</td>
                                  <td className={getAlertClass(alerts, 'LDL')}>{info.ldlCholesterol}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <h2>Diagnoses</h2>
                        <div className="table-responsive">
                          <table className="table table-bordered table-condensed">
                            <thead>
                              <tr>
                                <th>ICD&nbsp;Code</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              {info.ICD1 && (
                                <tr className={this.isICDInLookup(info.ICD1) ? mskFlagClass : ''}>
                                  <td>{info.ICD1}</td>
                                  <td>
                                    {info.ICD1Description}
                                    {this.isICDInLookup(info.ICD1) &&
                                      <div className={`label label-${mskFlagClass} pull-right`}>MSK</div>
                                    }
                                  </td>
                                </tr>
                              )}
                              {info.ICD2 && (
                                <tr className={this.isICDInLookup(info.ICD2) ? mskFlagClass : ''}>
                                  <td>{info.ICD2}</td>
                                  <td>
                                    {info.ICD2Description}
                                    {this.isICDInLookup(info.ICD2) &&
                                      <div className={`label label-${mskFlagClass} pull-right`}>MSK</div>
                                    }
                                  </td>
                                </tr>
                              )}
                              {info.ICD3 && (
                                <tr className={this.isICDInLookup(info.ICD3) ? mskFlagClass : ''}>
                                  <td>{info.ICD3}</td>
                                  <td>{info.ICD3Description}
                                    {this.isICDInLookup(info.ICD3) &&
                                      <div className={`label label-${mskFlagClass} pull-right`}>MSK</div>
                                    }
                                  </td>
                                </tr>
                              )}
                              {info.ICD4 && (
                                <tr className={this.isICDInLookup(info.ICD4) ? mskFlagClass : ''}>
                                  <td>{info.ICD4}</td>
                                  <td>
                                    {info.ICD4Description}
                                    {this.isICDInLookup(info.ICD4) &&
                                      <div className={`label label-${mskFlagClass} pull-right`}>MSK</div>
                                    }
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <h2>Procedures</h2>
                        <div className="table-responsive">
                          <table className="table table-bordered table-condensed">
                            <thead>
                              <tr>
                                <th>CPT&nbsp;Code</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              {info.CPT1 && (
                                <tr>
                                  <td>{info.CPT1}</td>
                                  <td>{info.CPT1Description}</td>
                                </tr>
                              )}
                              {info.CPT2 && (
                                <tr>
                                  <td>{info.CPT2}</td>
                                  <td>{info.CPT2Description}</td>
                                </tr>
                              )}
                              {info.CPT3 && (
                                <tr>
                                  <td>{info.CPT3}</td>
                                  <td>{info.CPT3Description}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <h2>Medications</h2>
                        <div className="table-responsive">
                          <ReactTable
                            className="-striped -highlight"
                            loading={isMedicationsLoading}
                            data={
                              medications.length > 0 && !isMedicationsLoading
                                ? medications
                                : []
                            }
                            minRows={1}
                            sortable={false}
                            pagination={false}
                            showPagination={false}
                            freezeWhenExpanded={view === 'VISIT_NOTE_VIEW'}
                            columns={[
                              {
                                Header: 'Type/Origin',
                                Cell: row => (
                                  `${row.original.type} | ${row.original.origin}`
                                ),
                              },
                              {
                                Header: 'Name',
                                accessor: 'displayedName',
                                Cell: row => (
                                  <span>
                                    <label>{row.original.displayedName}</label>
                                    <div hidden={!row.original.controlled} className="label label-danger pull-right">CS</div>
                                  </span>
                                ),
                              },
                              {
                                Header: 'Directions',
                                accessor: 'directions',
                              },
                              {
                                Header: 'Qty/Units',
                                Cell: row => (
                                  `${row.original.quantity ? row.original.quantity : ''} ${row.original.units ? row.original.units : ''}`
                                ),
                              }
                            ]}
                            SubComponent={row => (
                              <div
                                style={{
                                  padding: '20px',
                                  backgroundColor: 'rgba(0,0,0,0.01)',
                                }}
                              >
                                <dl>
                                  <dt>Med Type</dt>
                                  <dd>{row.original.medicationType}</dd>
                                  <dt>Route</dt>
                                  <dd>{row.original.route}</dd>
                                  <dt>Auth Refills</dt>
                                  <dd>{row.original.authRefills}</dd>
                                  <dt>Start Date</dt>
                                  <dd>
                                    <Moment
                                      date={row.original.startDate}
                                      format="MM/DD/YYYY"
                                    />
                                  </dd>
                                  <dt>Pharmacy Instructions</dt>
                                  <dd>{row.original.pharmacyInstructions}</dd>
                                </dl>
                              </div>
                            )}
                          />
                          <table className="table table-bordered table-condensed hide">
                            <thead>
                              <tr>
                                <th>Rx Type</th>
                                <th>Rx Name</th>
                                <th>Controlled</th>
                                <th>Maintenance</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{info.rxType}</td>
                                <td>{info.rxName}</td>
                                <td>{info.controlledFlag}</td>
                                <td>{info.maintenanceFlag}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <h2>Referrals</h2>
                        <div className="table-responsive">
                          <table className="table table-bordered table-condensed">
                            <thead>
                              <tr>
                                <th>Type</th>
                                <th>Details</th>
                                <th>Reason</th>
                                <th>VBN</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{info.referralType}</td>
                                <td>{info.referralOrg}</td>
                                <td>{info.referralReason}</td>
                                <td>{info.VBN}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <h2>Assessment &amp; Plan {isBulletsLoading && <div className="spinner inline" />}</h2>
                        <div className="col-md-6">
                          <dl>
                            <dt>Review Of Systems</dt>
                            <dd>{info.reviewOfSystems}</dd>
                            <dt>PhysicalExam</dt>
                            <dd>{info.physicalExam}</dd>
                            <dt>Narrative</dt>
                            <dd>{info.narrative}</dd>
                            <dt>Data</dt>
                            <dd>{info.data}</dd>
                          </dl>
                        </div>
                        <div className="col-md-6">
                          <dl>
                            <dt>Assessplan</dt>
                            <dd>{info.assessPlan}</dd>
                            <dt>Procedure</dt>
                            <dd>{info.procedure}</dd>
                            <dt>Followup</dt>
                            <dd>{info.followUp}</dd>
                            <dt>Review Notes</dt>
                            <dd>{actions && actions.total > 0 ? 'Yes' : 'No'}</dd>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="s2">
                  <div className="row">
                    <div className="col-md-6">
                      <h3>Past Medical History</h3>
                      <dl>
                        <dt>Allergies</dt>
                        <dd>{[info.allergy1, info.allergy2, info.allergy3, info.allergy4].filter(val => val !== null).join(', ')}</dd>
                        <dt>Past</dt>
                        <dd>{info.past}</dd>
                        <dt>Surgical</dt>
                        <dd>{info.surgical}</dd>
                        <dt>Social</dt>
                        <dd>{info.social}</dd>
                        <dt>Family</dt>
                        <dd>{info.family}</dd>
                        <dt>Habits</dt>
                        <dd>{info.habits}</dd>
                        <dt>Med</dt>
                        <dd>{info.med}</dd>
                      </dl>
                    </div>
                    <div className="col-md-6">
                      <h3>Claims Data</h3>
                      {history &&
                        <dl>
                          <dt>Member ID</dt>
                          <dd>{history.viMember && history.viMember.memberId}</dd>
                          <dt>Policy ID</dt>
                          <dd>{history.viMember && history.viMember.policyId}</dd>
                          <dt>Subscriber ID</dt>
                          <dd>{history.viMember && history.viMember.subscriberId}</dd>
                          <dt>ACG Prospective Risk Score</dt>
                          <dd>{history.viMember && history.viMember.prospectiveRiskScore && `${(history.viMember.prospectiveRiskScore * 100).toFixed(2)}%`}</dd>
                          <dt>ACG Concurrent Risk Score</dt>
                          <dd>{history.viMember && history.viMember.ConcurrentRiskScore && `${(history.viMember.ConcurrentRiskScore * 100).toFixed(2)}%`}</dd>
                          <dt>First Enrolled Date</dt>
                          <dd>{history.riskPVT &&
                            <Moment
                              date={history.riskPVT.enrolledFirstDate}
                              format="MM/DD/YYYY"
                            />}
                          </dd>
                          <dt>Last Enrolled Date</dt>
                          <dd>{history.riskPVT &&
                            <Moment
                              date={history.riskPVT.enrolledLastDate}
                              format="MM/DD/YYYY"
                            />}
                          </dd>
                          <dt>Months on Plan</dt>
                          <dd>{history.riskPVT && history.riskPVT.monthsOnPlan}</dd>
                          <dt>Total Paid Range</dt>
                          <dd>{history.riskPVT && history.riskPVT.totalPaidRange}</dd>
                          <dt>PCP Name</dt>
                          <dd>{history.riskPVT && history.riskPVT.stdPcpName}</dd>
                        </dl>
                      }
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                      <h3>Performance & Probabilities</h3>
                      <div className="table table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Segment</th>
                              <th>Cost</th>
                              <th>Cost Band</th>
                              <th>Predictive Cost Range</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th>Pharmacy</th>
                              <td>{history.riskPVT && `$${history.riskPVT.pharmacyCost}`}</td>
                              <td>{history.riskPVT && history.riskPVT.pharmacyCostBand}</td>
                              <td>{history.riskPVT && history.riskPVT.predictedPharmacyCostRange}</td>
                            </tr>
                            <tr>
                              <th>Total</th>
                              <td>{history.riskPVT && `$${history.riskPVT.totalCost}`}</td>
                              <td>{history.riskPVT && history.riskPVT.totalCostBand}</td>
                              <td>{history.riskPVT && history.riskPVT.predictedTotalCostRange}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="table table-responsive">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Inpatient Hospital Admission</th>
                              <th>Inpatient Hospital Admission &lt; 6 mo.</th>
                              <th>ICU Hospital</th>
                              <th>Injury Hospital</th>
                              <th>Extended Hospital</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{history.riskPVT && history.riskPVT.probabilityIPHosp && `${(history.riskPVT.probabilityIPHosp * 100).toFixed(2)}%`}</td>
                              <td>{history.riskPVT && history.riskPVT.probabilityIPHosp6MOS && `${(history.riskPVT.probabilityIPHosp6MOS * 100).toFixed(2)}%`}</td>
                              <td>{history.riskPVT && history.riskPVT.probabilityICUHosp && `${(history.riskPVT.probabilityICUHosp * 100).toFixed(2)}%`}</td>
                              <td>{history.riskPVT && history.riskPVT.probabilityINJURYHosp && `${(history.riskPVT.probabilityINJURYHosp * 100).toFixed(2)}%`}</td>
                              <td>{history.riskPVT && history.riskPVT.probabilityExtendedHosp && `${(history.riskPVT.probabilityExtendedHosp * 100).toFixed(2)}%`}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                      <h3>Utilization</h3>
                      <div className="table table-responsive">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <td>Active Ingredients</td>
                              <td>{history.riskPVT && history.riskPVT.activeIngredientCount}</td>
                            </tr>
                            <tr>
                              <td>ER Visits</td>
                              <td>{history.riskPVT && history.riskPVT.emergencyVisitCount}</td>
                            </tr>
                            <tr>
                              <td>Inpatient Admissions</td>
                              <td>{history.riskPVT && history.riskPVT.inpatientHospitalizationCount}</td>
                            </tr>
                            <tr>
                              <td>Outpatient Visits</td>
                              <td>{history.riskPVT && history.riskPVT.outpatientVisitCount}</td>
                            </tr>
                            <tr>
                              <td colSpan="2">{` `}</td>
                            </tr>
                            <tr>
                              <td>Major Procedure Performed</td>
                              <td>{history.riskPVT && history.riskPVT.majorProcedure}</td>
                            </tr>
                            <tr>
                              <td>Cancer Treatment</td>
                              <td>{history.riskPVT && history.riskPVT.cancerTreatment}</td>
                            </tr>
                            <tr>
                              <td>Dialysis Service</td>
                              <td>{history.riskPVT && history.riskPVT.dialysisService}</td>
                            </tr>
                            <tr>
                              <td>Nursing Service</td>
                              <td>{history.riskPVT && history.riskPVT.nursingService}</td>
                            </tr>
                            <tr>
                              <td>Psychotherapy Service</td>
                              <td>{history.riskPVT && history.riskPVT.psychotherapyService}</td>
                            </tr>
                            <tr>
                              <td>Readmissions (within 30 days)</td>
                              <td>{history.riskPVT && history.riskPVT.readmission30DayCount}</td>
                            </tr>
                            <tr>
                              <td>Unplanned Inpatient Hospitalizations</td>
                              <td>{history.riskPVT && history.riskPVT.unplannedInpatientHospitalizationCount}</td>
                            </tr>
                            <tr>
                              <td>Unplanned Readmissions (within 30 days)</td>
                              <td>{history.riskPVT && history.riskPVT.unplannedReadmission30DayCount}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                      <h3>Coordination of Care</h3>
                      <div className="table table-responsive">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <td>Coordination Risk</td>
                              <td>{history.riskPVT && history.riskPVT.coordinationRisk}</td>
                            </tr>
                            <tr>
                              <td># of Unique Providers Seen</td>
                              <td>{history.riskPVT && history.riskPVT.uniqueProviderCount}</td>
                            </tr>
                            <tr>
                              <td>Generalist Seen</td>
                              <td>{history.riskPVT && history.riskPVT.generalistSeen}</td>
                            </tr>
                            <tr>
                              <td>Specialists Seen</td>
                              <td>{history.riskPVT && history.riskPVT.specialityCount}</td>
                            </tr>
                            <tr>
                              <td>Major ADG Count</td>
                              <td>{history.riskPVT && history.riskPVT.majorADGCount}</td>
                            </tr>
                            <tr>
                              <td>Frailty Flag</td>
                              <td>{history.riskPVT && history.riskPVT.frailtyFlag}</td>
                            </tr>
                            <tr>
                              <td>Pregnancy without Delivery</td>
                              <td>{history.riskPVT && history.riskPVT.pregnancyWithoutDelivery}</td>
                            </tr>
                            <tr>
                              <td>Hospital Dominant Morbidity Types</td>
                              <td>{history.riskPVT && history.riskPVT.hospitalDominantMorbidityTypes}</td>
                            </tr>
                            <tr>
                              <td>Chronic Conditions</td>
                              <td>{history.riskPVT && history.riskPVT.chronicConditionCount}</td>
                            </tr>
                            <tr>
                              <td>Diagnoses Used</td>
                              <td>{history.riskPVT && history.riskPVT.diagnosesUsed}</td>
                            </tr>
                            <tr>
                              <td>Total Rx Gaps</td>
                              <td>{history.riskPVT && history.riskPVT.TotalRxGaps}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                      <h3>Medical Claims</h3>
                      {history && history.medicalClaims &&
                        <ReactTable
                          columns={[
                            {
                              Header: 'Date of Service',
                              accessor: 'dateOfServiceStartDate',
                              Cell: row => (
                                <Moment
                                  date={row.original.dateOfServiceStartDate}
                                  format="MM/DD/YYYY"
                                />
                              ),
                            },
                            {
                              Header: 'Place of Service',
                              accessor: 'placeOfServiceGeneral',
                            },
                            {
                              Header: 'Reason',
                              accessor: 'primaryEDC',
                            },
                            {
                              Header: 'Procedure',
                              accessor: 'procedureName',
                            },

                            {
                              Header: 'Carrier',
                              accessor: 'carrierName',
                            },
                            {
                              Header: 'Service Category',
                              accessor: 'serviceTypeSubcat',
                            },
                          ]}
                          className="-striped -highlight"
                          loading={isHistoryLoading}
                          data={
                            history.medicalClaims ? history.medicalClaims
                              : []
                          }
                          minRows={4}
                          sortable={true}
                          defaultSorted={[
                            {
                              id: "dateOfServiceStartDate",
                              desc: true
                            }
                          ]}
                          showPaginationTop={false}
                          pageSize={25}
                          freezeWhenExpanded={true}
                          filterable
                          defaultFilterMethod={filterCaseInsensitive}
                          />
                        }
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-md-12">
                      <h3>Rx Claims</h3>
                      {history && history.rxClaims &&
                        <ReactTable
                          columns={[
                            {
                              Header: 'Name',
                              accessor: 'drugName',
                            },
                            {
                              Header: 'Plan Paid Amount',
                              accessor: 'planPaidAmount',
                            },
                            {
                              Header: 'Fill Date',
                              accessor: 'filledAt',
                              Cell: row => (
                                <Moment
                                  date={row.original.filledAt}
                                  format="MM/DD/YYYY"
                                />
                              ),
                            },
                            {
                              Header: 'Days Supply',
                              accessor: 'daysSupply',
                            },
                          ]}
                          className="-striped -highlight"
                          loading={isHistoryLoading}
                          data={
                            history && history.rxClaims ? history.rxClaims
                              : []
                          }
                          minRows={4}
                          sortable={true}
                          defaultSorted={[
                            {
                              id: "filledAt",
                              desc: true
                            }
                          ]}
                          showPaginationTop={false}
                          pageSize={25}
                          freezeWhenExpanded={true}
                          filterable
                          defaultFilterMethod={filterCaseInsensitive}
                        />
                      }
                    </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="s3">
                    <ReactTable
                      className="-striped -highlight"
                      loading={isEncountersLoading}
                      data={
                        encounters && !isEncountersLoading
                          ? encounters.list
                          : []
                      }
                      minRows={4}
                      sortable={false}
                      pagination={false}
                      showPagination={false}
                      freezeWhenExpanded={true}
                      columns={[
                        {
                          Header: '',
                          id: 'actions',
                          sortable: false,
                          width: 60,
                          Cell: row => (
                            <span>
                              <Link
                                to={`/visit-note/${row.original.visitNoteID}`}
                                target="_blank"
                                className="btn btn-xs btn-default"
                              >
                                <i className="fa fa-external-link" />
                              </Link>
                            </span>
                          ),
                        },
                        {
                          Header: 'Visit Note ID',
                          accessor: 'visitNoteID',
                        },
                        {
                          Header: 'Patient ID',
                          accessor: 'patientID',
                        },
                        {
                          Header: 'Practice Name',
                          accessor: 'practiceName',
                        },
                        {
                          Header: 'Employer Desc',
                          accessor: 'employerDescription',
                        },
                        {
                          Header: 'Date of Service',
                          accessor: 'dateOfService',
                          Cell: row => (
                            <Moment
                              date={row.original.dateOfService}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Visit Reason',
                          accessor: 'visitReason',
                        },
                      ]}
                      defaultSorted={[
                        {
                          id: "dateOfService",
                          desc: true
                        }
                      ]}
                      SubComponent={row => (
                        <div
                          style={{
                            padding: '20px',
                            backgroundColor: 'rgba(0,0,0,0.01)',
                          }}
                        >
                          <VisitNoteCard
                            key={row.original.visitNoteID}
                            id={row.original.visitNoteID}
                            limits={limits}
                            simpleView={false}
                          />
                        </div>
                      )}
                    />
                    {encounters &&
                      encounters.total > 0 && (
                        <div className="table-responsive hide">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>Visit Note ID</th>
                                <th>Patient ID</th>
                                <th>Practice Name</th>
                                <th>Employer Desc</th>
                                <th>Date of Service</th>
                                <th>Visit Reason</th>
                              </tr>
                            </thead>
                            <tbody>
                              {encounters.list.map(encounter => (
                                <tr key={encounter.visitNoteID}>
                                  <td>
                                    <Link
                                      to={`/visit-note/${
                                        encounter.visitNoteID
                                      }`}
                                      target="_blank"
                                    >
                                      {encounter.visitNoteID}
                                    </Link>
                                  </td>
                                  <td>{encounter.patientID}</td>
                                  <td>{encounter.practiceName}</td>
                                  <td>{encounter.employerDescription}</td>
                                  <td>
                                    <Moment
                                      date={encounter.dateOfService}
                                      format="MM/DD/YYYY"
                                    />
                                  </td>
                                  <td>{encounter.visitReason}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                  </div>
                  <div className="tab-pane fade" id="s4">
                    {actions &&
                      actions.total > 0 && (
                        <div className="smart-timeline">
                          <ul className="smart-timeline-list">
                            {this.sortedActions().map(action => (
                              <li key={action.id}>
                                <div className="smart-timeline-icon">
                                  <i
                                    className={`fa ${this.getActionClass(
                                      action,
                                    )}`}
                                  />
                                </div>
                                <div className="smart-timeline-time">
                                  <small>
                                    <Moment
                                      date={action.createdAt}
                                      format="MMM Do, YYYY"
                                    />
                                    <br />
                                    <Moment
                                      date={action.createdAt}
                                      format="h:mm a"
                                    />
                                  </small>
                                </div>
                                <div className="smart-timeline-content">
                                  <p>
                                    <strong>
                                      {this.getActionWording(action)} by{' '}
                                      {action.user && (
                                        <span>
                                          {action.user.firstName}{' '}
                                          {action.user.lastName}
                                        </span>
                                      )}
                                    </strong>
                                  </p>
                                  <p>{action.note}</p>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    {actions &&
                      actions.total === 0 && (
                        <div className="text-center">
                          <strong>No Reviews</strong>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div ref="form" className="review-notes">
                {showNotes && (
                  <ReviewForm
                    visitNoteID={info.visitNoteID}
                    view={view}
                    flags={{
                      mskFlag: info.mskFlag,
                      mskFlag2: info.mskFlag2,
                    }}
                    editFlagsMode={editFlagsMode}
                    toggleNotes={toggleNotes}
                    onSubmit={addAction}
                    isLoading={isActionSubmitting}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {!info && (
          <div className="widget-body clinic-activity-widget-body empty-chart-review">
            <div>
              <i className="fa fa-lock fa-4x" />
              <h4>Select a chart to show content here</h4>
              <p>This blank page message helps protect your privacy.</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/VisitView.js